import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import styles from './field-error.css'

const FieldError = ({ data }) => {
  if (data.touched && data.error) {
    return <div styleName="error">{data.error}</div>
  }

  return <div />
}

FieldError.propTypes = {
  data: PropTypes.object,
}

export default CSSModules(FieldError, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/field-error/field-error.js
 **/